export const BASE_IMPORT_DATA = {
  PLAYERS: {
    dataName: "Players",
    shouldUniqueColumn: "Player ID",
    requiredColumns: [
      "Status",
      "Show Profile?",
      "Sport ID",
      "Player ID",
      "Player Type ID",
      "Birth Year",
      "Birth Month",
      "Birth Day",
      "Birth City",
      "Birth Country ID",
      "Height",
      "Is Notable Player",
      "Is Legend Player",
      "Nationality ID 1",
      // "Sub Tittle",
      // "History Content",
    ],
    columnNames: [
      "MPL Status",
      "Show Profile?",
      "Sport ID",
      "Player ID",
      "Player Type ID",
      "Birth Year",
      "Birth Month",
      "Birth Day",
      "Birth City",
      "Birth Country ID",
      "Height",
      "Is Notable Player",
      "Is Legend Player",
      "Nationality ID 1",
    ],
    codeColumnName: "Player ID",
  },
  PLAYER_CAREERS: {
    dataName: "Player Careers",
    shouldBeUniqueCompositeColumns: ["Player ID", "Term ID", "Team ID"],
    columns: ["Player ID", "Term ID", "Team ID"],
  },
  PLAYER_TYPES: {
    dataName: "Player Types",
    codeColumnName: "Player Type ID",
    columnNames: ["Status", "Sport ID", "Player Type"],
  },

  EVENT_PARTICIPANTS: {
    dataName: "Event Achievements",
    codeColumnName: "ID",
    shouldBeUniqueCompositeColumns: ["Team ID", "Competition ID", "Term ID"],
    columnNames: ["Competition ID", "Term ID", "Team ID", "Rank"],
  },
  TEAM_NOTABLE_ACHIEVEMENTS: {
    dataName: "Team Notable Achievements",
    shouldBeUniqueCompositeColumns: ["Competition ID", "Team ID", "Term ID", "Rank"],
    columns: ["Competition ID", "Team ID", "Term ID", "Rank"],
  },
};
